import React, { useEffect, useState } from 'react';
import { Grid, Header, Checkbox } from 'semantic-ui-react';

const styles = {
	root: {
		paddingTop: '20px',
		paddingBottom: '20px',
	},
};

//
const FilterTool = ({ optionsMap, onOptionsMapChange }) => {
	const [curOptionsMap, setCurOptionsMap] = useState(optionsMap || {});

	//
	useEffect(() => {
		if (onOptionsMapChange) {
			onOptionsMapChange(curOptionsMap);
		}
	}, [curOptionsMap]);

	//
	const handleCheckboxChange = (sec, optId) => (e, data) => {
		const newOptionsMap = { ...curOptionsMap };
		if (sec in newOptionsMap) {
			newOptionsMap[sec].data = newOptionsMap[sec].data.map((opt) => {
				if (opt.id === optId) {
					return {
						...opt,
						checked: data.checked,
					};
				}
				return opt;
			});
			setCurOptionsMap(newOptionsMap);
		}
	};
	//
	return (
		<div>
			{Object.entries(curOptionsMap).map(
				([sec, secObj], secIdx) =>
					secObj.public && (
						<Grid container style={styles.root} key={secIdx.toString()}>
							<Header>{secObj.title}</Header>
							{Array.isArray(secObj.data) &&
								secObj.data
									.filter((opt) => opt.public)
									.map((opt, idx) => (
										<Grid.Row key={idx.toString()}>
											<Checkbox
												label={opt.label}
												checked={opt.checked}
												onChange={handleCheckboxChange(sec, opt.id)}
											/>
										</Grid.Row>
									))}
						</Grid>
					)
			)}
		</div>
	);
};

export default FilterTool;
